var chunkMapping = {
	"651": [
		8970,
		9216,
		9283
	],
	"845": [
		8845
	],
	"995": [
		1363,
		3609,
		4196,
		8117,
		9991
	],
	"996": [
		2567,
		7693,
		8520
	]
};
var idToExternalAndNameMapping = {
	"1363": [
		"default",
		"./StagedContentAssistantOverview",
		3215
	],
	"2567": [
		"default",
		"./hooks",
		6308
	],
	"3609": [
		"default",
		"./Link",
		2804
	],
	"4196": [
		"default",
		"./utils",
		3215
	],
	"7693": [
		"default",
		"./Selectors",
		2804
	],
	"8117": [
		"default",
		"./manifest",
		5980
	],
	"8520": [
		"default",
		"./Selectors",
		5980
	],
	"8845": [
		"default",
		"./Store",
		5980
	],
	"8970": [
		"default",
		"./isAuthorized",
		2804
	],
	"9216": [
		"default",
		"./server",
		6308
	],
	"9283": [
		"default",
		"./unboxing-page",
		6308
	],
	"9991": [
		"default",
		"./hooks",
		3215
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}